import React, { useState, useEffect, useMemo } from 'react';
import { CircularProgress, Grid, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarDensitySelector, roRO } from '@mui/x-data-grid-pro';
import { GridFilterInputDate, GridFilterInputDateRange, getGridDateOperators } from '@mui/x-data-grid-pro';
import verificareToken from '../VerificareToken';
import { LicenseInfo } from '@mui/x-license-pro';
import { addDays, startOfWeek, format } from 'date-fns';
import DateFilterComponent from '../DateFilterComponent';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

LicenseInfo.setLicenseKey(
  'c3a5a1d9f60b480a65b2c0d133d555d5Tz0xMzAxNzUsRT0xODEyOTMxMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI='
);

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function getIdClient() {
  let idclient = getCookie('_iduserCjpc');
  
  if (!idclient) {
      idclient = sessionStorage.getItem('iduser');
  }

  if (!idclient) {
      idclient = localStorage.getItem('iduser');
  }

  return idclient;
}

function LogNotificariUser() {

  window.dispatchEvent(new Event('authChange'));

  const [notificariLog, setNotificariLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(0);

  const idclient = getIdClient();
  const { token } = verificareToken(); 

  const calculateWeekRanges = () => {
    const weeks = [];
    const now = new Date();
    for (let i = 0; i <= 4; i++) {  // Ajustăm pentru a include și săptămâna curentă
      const start = startOfWeek(addDays(now, -7 * i), { weekStartsOn: 1 });
      const end = addDays(start, 6);
      weeks.push({
        week: i,
        start: format(start, 'dd.MM.yyyy'),
        end: format(end, 'dd.MM.yyyy')
      });
    }
    return weeks;
  };

  const weekRanges = calculateWeekRanges();

  
  
const dateFilterOperators = useMemo(() => [
  {
    label: 'egal cu',
    value: 'contains',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) {
        return null;
      }
      return (params) => {
        const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
        const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
        return dateFromRow === selectedDate;
      };
    },
    InputComponent: DateFilterComponent,
  },
  {
    label: 'înainte de',
    value: 'before',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) {
        return null;
      }
      return (params) => {
        const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
        const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
        return dateFromRow < selectedDate;
      };
    },
    InputComponent: DateFilterComponent,
  },
  {
    label: 'după data',
    value: 'after',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) {
        return null;
      }
      return (params) => {
        const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
        const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
        return dateFromRow > selectedDate;
      };
    },
    InputComponent: DateFilterComponent,
  },
], []);

  const columns = [
    {

      field: 'data', 
      headerName: 'Data', 
      width: 250,
      filterable: true,
      filterOperators: dateFilterOperators,
      valueFormatter: ({ value }) => formatDate(value),
      renderCell: (params) => (
        params.value ? <span>{formatDate(params.value)}</span> : <span>-</span>
      ), 
    },
    { field: 'mesaj', headerName: 'Activitate', flex: 1, wordWrap: true },
  ];
  
  
  const fetchNotificariLog = async (saptamana) => {
    const response = await fetch(`${window.API_URL}getNotificariExterne?saptamana=${saptamana}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/plain',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Eroare preluare log notificari utilizator');
    }

    const data = await response.json();
    return data.data.notificari.Loguri || [];
  };

  useEffect(() => {
    const fetchWeekData = async () => {
      try {
        setLoading(true);
        const data = await fetchNotificariLog(selectedWeek);
        setNotificariLog(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchWeekData();
  }, [selectedWeek, idclient]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
        <CircularProgress />
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}.${formattedMonth}.${year}`;
  };



  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  };

  const rows = notificariLog.map((item, index) => ({
    id: index,
    ...item,
    data: new Date(item.data)
  }));

  const handleWeekChange = (event) => {
    setSelectedWeek(event.target.value);
  };

  return (
    <div id="logActivitate">
      <FormControl fullWidth>
        <InputLabel id="select-week-label">Selectați săptămâna</InputLabel>
        <Select
          labelId="select-week-label"
          id="select-week"
          value={selectedWeek}
          onChange={handleWeekChange}
          label="Selectați săptămâna"
        >
          <MenuItem value={0}>Săptămâna curentă ({weekRanges[0].start} - {weekRanges[0].end})</MenuItem>
          <MenuItem value={1}>Săptămâna trecută ({weekRanges[1].start} - {weekRanges[1].end})</MenuItem>
          <MenuItem value={2}>Acum 2 săptămâni ({weekRanges[2].start} - {weekRanges[2].end})</MenuItem>
          <MenuItem value={3}>Acum 3 săptămâni ({weekRanges[3].start} - {weekRanges[3].end})</MenuItem>
          <MenuItem value={4}>Acum 4 săptămâni ({weekRanges[4].start} - {weekRanges[4].end})</MenuItem>
        </Select>
      </FormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DataGridPro
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50, 100]}
            pagination
            paginationMode="client"
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            components={{
              Toolbar: CustomToolbar,
            }}
            localeText={{
              ...roRO.components.MuiDataGrid.defaultProps.localeText,
              headerFilterOperatorContains: 'Filtrare rapidă',
              filterPanelRemoveAll: 'Resetare filtre',
              toolbarExport: 'Export',
              toolbarExportLabel: 'Export',
              toolbarExportCSV: 'În format CSV',
              toolbarExportPrint: 'Imprimare',
              toolbarExportExcel: 'În format Excel',
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default LogNotificariUser;
